import MailNotificationContainer from './MailNotification.container';

const Notifications = () => <MailNotificationContainer />;

export default Notifications;
